var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.selectedImage.obj.id === _vm.imgobj.id ? 'image attachment-image active' : 'attachment-image image',on:{"click":function($event){return _vm.selectImage(_vm.imgobj)}}},[_c('img',{attrs:{"src":_vm.imageSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }